import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import parse from 'html-react-parser';
import { useWistia } from '@miro-site/core';
import template from './feature-3.twig';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var backgroundColors = {
  white: {
    background: '',
    headline: '',
    text: '',
    primaryButton: '',
    secondaryButton: 'transparent',
    link: ''
  },
  indigo: {
    background: 'indigo',
    headline: 'white',
    text: 'white',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'white'
  },
  blue: {
    background: 'blue',
    headline: 'white',
    text: 'white',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'white'
  },
  red: {
    background: 'red',
    headline: 'white',
    text: 'white',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'white'
  },
  pink: {
    background: 'pink',
    headline: 'indigo',
    text: 'indigo',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'indigo'
  },
  yellow: {
    background: 'yellow',
    headline: 'indigo',
    text: 'indigo',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'indigo'
  },
  grey: {
    background: 'grey',
    headline: '',
    text: '',
    primaryButton: '',
    secondaryButton: 'transparent',
    link: ''
  }
};

var Feature3 = function Feature3(props) {
  var _props$items;

  var hasVideo = (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.some(function (_ref) {
    var video = _ref.video;
    return video === null || video === void 0 ? void 0 : video.id;
  });

  if (hasVideo) {
    useWistia();
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: parse(template(_objectSpread(_objectSpread({}, props), {}, {
      backgroundColors: backgroundColors,
      component_name: 'Feature Section',
      ctf_assets: 'images.ctfassets.net'
    })))
  });
};

export default Feature3;